module.exports = __webpack_public_path__ + "static/media/kite_surfing.a2708812.jpg";